<template>
  <s-modal
    v-model="showModal"
    :title="$t('messages.MC050.title')"
    :ok-title="$t('general.confirm')"
    :ok-disabled="$v.$invalid"
    :is-loading="isLoading"
    @cancel="cancelRemoveActionHandler"
    @ok="removeIedActionHandler"
  >
    <p>{{ $t('messages.MC050.message') }}</p>
    <b-form-group v-slot="{ ariaDescribedby }">
      <b-form-radio-group
        v-model="$v.selectedRemovalActionMode.$model"
        name="delete-actions-radios"
        stacked
        :options="removalActionModes"
        :aria-describedby="ariaDescribedby"
        :state="$bsStateValidator($v.$error)"
      />
      <b-form-invalid-feedback :state="$bsStateValidator($v.$error)">
        {{ $t('engineering.commutator-maintenance.select-an-option') }}
      </b-form-invalid-feedback>
    </b-form-group>
  </s-modal>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { CommutatorMaintenanceActionExclusionMode } from 'sigma-mappings';

export default {
  name: 'RemoveIedActionModal',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      defaut: false,
    },
  },
  data: () => ({
    selectedRemovalActionMode: null,
  }),
  validations: {
    selectedRemovalActionMode: {
      required,
    },
  },
  computed: {
    showModal: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    removalActionModes() {
      return [
        {
          text: this.$t('engineering.commutator-maintenance.delete-and-resolve-later'),
          value: CommutatorMaintenanceActionExclusionMode
            .RESOLVE_PENDING_LATER,
        },
        {
          text: this.$t('engineering.commutator-maintenance.automatically-exclude-and-link'),
          value: CommutatorMaintenanceActionExclusionMode
            .AUTOMATICALLY_BIND_UNEXPECTED_MAINTENANCE_EVENT,
        },
      ];
    },
  },
  methods: {
    resetRemoveActionRadio() {
      this.$v.selectedRemovalActionMode.$model = null;
      this.$nextTick(() => this.$v.$reset());
    },
    cancelRemoveActionHandler() {
      this.resetRemoveActionRadio();
      this.$emit('cancel');
    },
    removeIedActionHandler() {
      this.$v.$touch();

      if (!this.$v.$error) {
        this.$emit('remove-action', this.selectedRemovalActionMode, this.resetRemoveActionRadio);
      }
    },
  },
};
</script>
